import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {},
  state: {
      foundation: 'sho',
      loadingOverlay: false
  },
  mutations: {
    setFoundation: (state, payload) => {
        state.foundation = payload;
    },
    setLoadingState: (state, payload) => {
        state.loadingOverlay = payload;
    }
  },
  actions: {}
});

export default store;
